import { render } from "./apptemplate.vue?vue&type=template&id=5446593a"
import script from "./apptemplate.vue?vue&type=script&lang=js"
export * from "./apptemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__